import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Assessments';

const AssessmentsApi: any = baseApi(endpoint);

export default AssessmentsApi;